import { createSelector } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { AUTOCOMPLETE_MAX_ITEMS } from '../../utils/constants';
import { CancelToken } from 'axios';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { EstablishmentDto } from '@api/models/establishment/EstablishmentDto';
import { EntityState } from '@api/models/enums/EntityState';
import { establishmentService } from '@api/services/services';

type State = BaseType<EstablishmentDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const optionsEstablishmentSlice = baseSlice({
  name: 'optionsEstablishment',
  initialState,
});

export const selectOptionsEstablishmentState = (state: RootState) => state.optionsEstablishment.state;
export const selectOptionsEstablishment = (state: RootState) =>
  state.optionsEstablishment.data.map((x) => ({ id: x.id, name: x.name, nameEn: x.nameEn } as ReferenceDto));
export const optionsEstablishmentActions = optionsEstablishmentSlice.actions;

export const getOptionsEstablishment = (search: string | undefined, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const handleGetData = async () => {
    const response = await establishmentService.query(
      {
        q: search,
        state: EntityState.Active,
        nameOnly: true,
        page: 0,
        size: AUTOCOMPLETE_MAX_ITEMS,
        sort: ['name', 'asc'],
      },
      { cancelToken: cancelToken as any }
    );
    return { data: response.data.content ?? [] };
  };

  return getItem({
    dispatch,
    actions: optionsEstablishmentActions,
    getData: handleGetData,
  });
};
